document.addEventListener('DOMContentLoaded', () => {
    const faqContainer = document.querySelector('.telehealth-expertise .collapsible-content');

    const faqItems = document.querySelectorAll('.telehealth-expertise .collapsible-content__item');
    const toggleButtons = document.querySelectorAll('.telehealth-expertise .collapsible-content__toggle');
    const answerContents = document.querySelectorAll('.telehealth-expertise .collapsible-content__answer');

    const initialBackgrounds = Array.from(faqItems).map((item) => item.getAttribute('data-image'));

    function applyContainerBackground(imageUrl) {
        faqContainer.style.backgroundImage = `url(${imageUrl})`;
        faqContainer.style.backgroundRepeat = 'no-repeat';
        faqContainer.style.backgroundSize = 'cover';
        faqContainer.style.backgroundPosition = 'center';

        faqItems.forEach((item) => {
            item.style.backgroundImage = '';
        });
    }

    function resetFAQItemBackgrounds() {
        faqItems.forEach((item, index) => {
            const imageUrl = initialBackgrounds[index];
            item.style.backgroundImage = `url(${imageUrl})`;
            item.style.backgroundRepeat = 'no-repeat';
            item.style.backgroundSize = 'cover';
            item.style.backgroundPosition = 'center';
        });
    }

    toggleButtons.forEach((toggleButton, index) => {
        toggleButton.addEventListener('click', () => {
            const answerContent = answerContents[index];
            const isActive = answerContent.classList.contains('active');
            const plusIcon = toggleButton.querySelector('.plus');
            const minusIcon = toggleButton.querySelector('.minus');

            answerContent.classList.toggle('active');
            plusIcon.style.display = isActive ? 'block' : 'none';
            minusIcon.style.display = isActive ? 'none' : 'block';

            answerContents.forEach((content, i) => {
                if (i !== index) {
                    content.classList.remove('active');
                    toggleButtons[i].querySelector('.plus').style.display = 'block';
                    toggleButtons[i].querySelector('.minus').style.display = 'none';
                }
            });

            const anyOpen = Array.from(answerContents).some((content) => content.classList.contains('active'));

            if (anyOpen) {
                const activeFaqItem = faqItems[index];
                const imageUrl = activeFaqItem.getAttribute('data-image');

                if (imageUrl) {
                    applyContainerBackground(imageUrl);
                }
                return;
            }
            resetFAQItemBackgrounds();
            faqContainer.style.backgroundImage = '';
        });
    });

    resetFAQItemBackgrounds();
});